var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.342,
    height: 160.935,
    viewBox: "0 0 158.342 160.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Megaphone",
    transform: "translate(0.004 30.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37481",
    "data-name": "Path 37481",
    d: "M123.959,421.871a9.053,9.053,0,0,0-.687-1.068c-1-1.35-2.224-2.7-2.553-4.405a6.979,6.979,0,0,1,.458-4.121,7.369,7.369,0,0,0,.4-4.256l-.007-.042a7.43,7.43,0,0,0-2.309-4.054,6.989,6.989,0,0,1-1.121-8.95,3.808,3.808,0,0,0,.6-2.179,3.7,3.7,0,0,0-.06-.58l-.194-1.053-1.893-10.3a8.853,8.853,0,1,0-17.412,3.21l1.123,6.116.247,1.35,5.3,28.9-.017.008q.441,2.9.879,5.807c.374,2.46.436,4.724,2.7,6.29a7.679,7.679,0,0,0,3.138,1.245,13.58,13.58,0,0,0,9.09-1.606c3.735-2.3,4.258-6.789,2.318-10.31Z",
    transform: "translate(-74.375 -303.199)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37482",
    "data-name": "Path 37482",
    d: "M36.472,303.7l-20.657,5.8-1.151.326-1.123.314a10.546,10.546,0,0,1-3.362.391,10.66,10.66,0,0,1-2.4-20.913l.667-.184,1.093-.314,21.167-5.947A10.662,10.662,0,1,1,36.47,303.7Z",
    transform: "translate(0 -234.998)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37483",
    "data-name": "Path 37483",
    d: "M97.615,379.206a64.006,64.006,0,0,1-1.477,7.5c-.575,1.905-1.84,4.286-3.708,5.2a13.328,13.328,0,0,1-3.076,1.009c-.782.164-1.576.3-2.351.426-.027,0-.042.007-.057.007-.383.065-.767.12-1.158.169a87.144,87.144,0,0,1-12.327.675c-11.9,0-19.541-17.41-19.541-17.41l31.833,1.763,11.866.66Z",
    transform: "translate(-40.496 -305.6)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37484",
    "data-name": "Path 37484",
    d: "M121.937,422.122c0,1.151-1.616,2.082-3.608,2.082s-3.608-.931-3.608-2.082,1.616-2.082,3.608-2.082S121.937,420.971,121.937,422.122Z",
    transform: "translate(-86.155 -338.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37485",
    "data-name": "Path 37485",
    d: "M166.189,384.522a64.01,64.01,0,0,1-1.477,7.5c-.575,1.905-1.84,4.286-3.708,5.2a13.327,13.327,0,0,1-3.076,1.009c-.782.164-1.576.3-2.351.426-.027,0-.042.007-.057.007-.384.065-.767.12-1.158.169l-.092-.022c-5.245-1.081-8.208-10.091-8.987-12.825l-.022-.085a.531.531,0,0,1,1.009-.334l.035.127c.64,2.224,4.022.675,8.021-1.833l11.866.66Z",
    transform: "translate(-109.07 -310.917)",
    fill: "#596268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37486",
    "data-name": "Path 37486",
    d: "M138.735,134.476s-13.345-6.522-37.837-8.783a271.662,271.662,0,0,0-34.655-.916c-5.8.219-9.236.56-9.236.56a15.78,15.78,0,0,1-16.563-11.881l-2.017-8.044A15.772,15.772,0,0,1,45.8,87.925s3.788-2.04,9.416-5.23c7.162-4.057,17.3-9.984,26.39-15.938,21.108-13.834,32.038-35.838,32.038-35.838Z",
    transform: "translate(-28.501 -45.869)",
    fill: "#a0afba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37487",
    "data-name": "Path 37487",
    d: "M325.368,115.58h-.007c-.334.092-.667.177-1,.256a23.28,23.28,0,0,1-4.874.59c-18.119.306-36.779-19.917-43.224-48.083s1.534-54.485,17.985-62.1A23.22,23.22,0,0,1,298.9,4.65c.349-.077.7-.149,1.051-.214C319.2.94,340.091,21.988,347,52.143s-2.757,58.238-21.628,63.438Z",
    transform: "translate(-205.79 -25.696)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 36.284,
    cy: 57.035,
    rx: 36.284,
    ry: 57.035,
    transform: "translate(62.136 -13.959) rotate(-12.9)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37488",
    "data-name": "Path 37488",
    d: "M372.607,130.889c-5.02,1.146-10.272-.227-15.233-3.569-.359-.234-.72-.486-1.071-.745-5.339-3.927-10.292-10.113-14.2-17.835a77.776,77.776,0,0,1-6.31-17.684,80.392,80.392,0,0,1-1.965-14.581A57.121,57.121,0,0,1,337,54.173c.179-.473.366-.939.565-1.392,3.063-7.2,7.882-12.182,14.04-13.6C366.142,35.857,382.625,53.685,388.425,79s-1.285,48.553-15.818,51.883Z",
    transform: "translate(-250.656 -51.773)",
    fill: "#a0afba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37489",
    "data-name": "Path 37489",
    d: "M369.673,197.273,342.268,209.48a77.937,77.937,0,0,1-6.31-17.679,79.844,79.844,0,0,1-1.967-14.581l28.28-4.291Z",
    transform: "translate(-250.82 -152.515)",
    fill: "#edf0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37490",
    "data-name": "Path 37490",
    d: "M448.783,180.424c1.586,6.923-.55,13.318-4.771,14.284s-8.928-3.862-10.512-10.785.55-13.318,4.771-14.284S447.2,173.5,448.783,180.424Z",
    transform: "translate(-325.156 -149.951)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37491",
    "data-name": "Path 37491",
    d: "M335.03,116.724c-.334.092-.667.177-1,.256a23.278,23.278,0,0,1-4.874.59c-6.871-1.043-13.814-4.839-20.209-11.149-9.274-9.159-16.294-22.54-19.76-37.681s-2.971-30.242,1.392-42.519c3.006-8.462,7.6-14.9,13.338-18.837a23.223,23.223,0,0,1,4.654-1.591c.349-.077.7-.149,1.051-.214-7.922,3.028-14.262,10.36-18.042,21-4.291,12.093-4.774,26.98-1.357,41.929s10.34,28.138,19.469,37.155c8.029,7.922,16.9,11.767,25.339,11.064Z",
    transform: "translate(-215.46 -26.84)",
    fill: "#596268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37492",
    "data-name": "Path 37492",
    d: "M66.243,280.911c-5.8.219-9.236.56-9.236.56A15.78,15.78,0,0,1,40.444,269.59l-2.017-8.044A15.772,15.772,0,0,1,45.8,244.06s3.788-2.04,9.416-5.23h.007s-6.151,3.1-1.133,22.744c3.374,13.231,9.652,17.87,12.155,19.335Z",
    transform: "translate(-28.501 -202.004)",
    fill: "#eae553"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37493",
    "data-name": "Path 37493",
    d: "M41.2,328.63l-1.151.326a16.606,16.606,0,0,1-3.681-7L34.3,313.724a16.686,16.686,0,0,1-.468-5.16l1.093-.314a15.474,15.474,0,0,0,.413,5.207L37.4,321.7a15.548,15.548,0,0,0,3.8,6.928Z",
    transform: "translate(-25.382 -254.136)",
    fill: "#596268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37494",
    "data-name": "Path 37494",
    d: "M69.01,390.506q-1.136,0-2.378-.017c-7.9-.117-12.158-6.527-12.334-6.8a.5.5,0,0,1,.147-.69.5.5,0,0,1,.692.144c.04.062,4.154,6.238,11.513,6.345a118.3,118.3,0,0,0,12.31-.354.5.5,0,0,1,.1.994c-.042.005-3.8.376-10.048.376Z",
    transform: "translate(-40.719 -310.209)",
    fill: "#596268"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37495",
    "data-name": "Path 37495",
    d: "M122.258,441.222c-1.223.1-4.6.326-9.535.326-.76,0-1.549-.007-2.381-.015a14.371,14.371,0,0,1-6.246-1.527l-.207-1.357a13.312,13.312,0,0,0,6.467,1.818c6.081.092,10.275-.184,11.739-.306l.164,1.058Z",
    transform: "translate(-78.022 -352.063)",
    fill: "#596268"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.ae2db2349b9acb809a74573e573d7c3e.svg";
export { ForwardRef as ReactComponent };